"use strict";

var _createClass = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/classCallCheck.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyStore = void 0;
/**
 * KeyStores are passed to {@link Near} via {@link NearConfig}
 * and are used by the {@link InMemorySigner} to sign transactions.
 *
 * @example {@link connect}
 */

var KeyStore = /*#__PURE__*/_createClass(function KeyStore() {
  _classCallCheck(this, KeyStore);
});

exports.KeyStore = KeyStore;